export enum MENU_TAB_ACCESS_KEY {
  PROJECT = "Project",
  BUILD = "Build",
}

export const AccessKeyTab: string[] = [
  MENU_TAB_ACCESS_KEY.PROJECT,
  MENU_TAB_ACCESS_KEY.BUILD,
]
